import { FC } from "react"
import { Icon, IconColor } from "@/components/shared/Icon"
import { MAIN_SUPPORT_EMAIL, MAIN_SUPPORT_PHONE } from "@/constants/globals"
import "./index.scss"

const LoginSupport: FC = () => {
   return (
      <div className="support">
         <div className="support-text">
            For support questions contact us at:
         </div>
         <div className="support-phone">
            <Icon
               name="support"
               color={IconColor.WHITE}
               size="16"
            />
            <span>{MAIN_SUPPORT_PHONE}</span>
         </div>
         <div className="support-email">
            <Icon
               name="envelope"
               color={IconColor.WHITE}
               size="16"
            />
            <a href={`mailto:${MAIN_SUPPORT_EMAIL}`}>{MAIN_SUPPORT_EMAIL}</a>
         </div>
      </div>
   )
}

export default LoginSupport
